/* Elia cart bundle upgrade: global binding survives AJAX drawer updates. */
(function () {
  'use strict';

  var reopenKey = 'elia-cart-upgrade-reopen';

  function storageGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (error) { return null; }
  }

  function storageSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (error) { /* Reload remains a safe fallback. */ }
  }

  function storageRemove(key) {
    try { window.sessionStorage.removeItem(key); } catch (error) { /* No action needed. */ }
  }

  function reopenDrawerAfterReload() {
    if (storageGet(reopenKey) !== 'true') return;
    storageRemove(reopenKey);
    window.requestAnimationFrame(function () {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    });
  }

  function bindUpgrade() {
    if (window.eliaCartUpgradeBound) return;
    window.eliaCartUpgradeBound = true;

    document.addEventListener('click', async function (event) {
      if (!(event.target instanceof Element)) return;
      var button = event.target.closest('[data-elia-cart-upgrade]');
      if (!button || button.disabled) return;

      var removeKey = String(button.dataset.removeKey || '');
      var addId = String(button.dataset.addId || '');
      if (!removeKey || !addId) return;

      var originalButtonText = button.textContent.trim();
      var status = button.parentElement ? button.parentElement.querySelector('[data-elia-cart-upgrade-status]') : null;
      button.disabled = true;
      button.textContent = 'Paket wird aktualisiert …';
      if (status) status.textContent = '';

      try {
        var updates = {};
        updates[removeKey] = 0;
        updates[addId] = 1;
        var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        var response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        if (!response.ok) throw new Error('Cart update failed');

        var cart = await response.json();
        var replacementAdded = cart.items && cart.items.some(function (item) {
          return String(item.variant_id) === addId && item.quantity > 0;
        });
        var oldItemRemoved = cart.items && cart.items.every(function (item) {
          return String(item.key) !== removeKey;
        });
        if (cart.errors || !replacementAdded || !oldItemRemoved) throw new Error('Cart state could not be confirmed');

        storageSet(reopenKey, 'true');
        window.location.reload();
      } catch (error) {
        button.disabled = false;
        button.textContent = originalButtonText;
        if (status) status.textContent = 'Aktualisierung nicht möglich. Bitte erneut versuchen.';
      }
    });
  }

  reopenDrawerAfterReload();
  bindUpgrade();
})();
